import React, { useEffect } from "react";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { getNotification, resetNotification } from "../../modules/notification";
import { getMessageString } from "../../tools";

const NotificationBase = ({ intl }) => {
  const notificationInStore = useSelector(getNotification);
  const dispatch = useDispatch();
  const actions = {
    closeNotification: () => dispatch(resetNotification()),
  };
  const onCloseNotification = () => actions.closeNotification();

  useEffect(() => {
    if (notificationInStore)
      notification.open({
        className: notificationInStore.className,
        ...(notificationInStore.message && { message: getMessageString(intl, notificationInStore.message) }),
        ...(notificationInStore.description && { description: getMessageString(intl, notificationInStore.description) }), //prettier-ignore
        icon: <>{notificationInStore.icon}</>,
        onClose: onCloseNotification,
        duration: notificationInStore.duration,
      });
    else notification.destroy();
    // eslint-disable-next-line
  }, [notificationInStore]);

  return <></>;
};

export const Notification = injectIntl(NotificationBase);
